"use strict";
function a(e, r) {
  return r ? e.replace(/\/?\/$/, "") + "/" + r.replace(/^\/+/, "") : e;
}
export {
  a as default
};
//# sourceMappingURL=index.es333.js.map
